// Подсчёт слов - один способ для строки состояния и «Файл → Сведения».
import type { Node as PMNode } from '@tiptap/pm/model';

export const WORD = /[\p{L}\p{N}]+(?:[-'’][\p{L}\p{N}]+)*/gu;

export function countWords(doc: PMNode, text?: string): number {
  const t = text ?? doc.textBetween(0, doc.content.size, '\n', ' ');
  return (t.match(WORD) || []).length;
}
